import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './Works.module.css';
// import ScrollVelocity from './ScrollVelocity';
import CardSwap, { Card } from './CardSwap';

const WorkCard = ({ image, title, category, link, isShort, isVideo }) => {
  return (
    <div className={`${styles.workCard} ${isShort ? styles.shortCard : ''}`}>
      <Link href={link} className={styles.workLink}>
        <div className={styles.workImageContainer}>
          {isVideo ? (
            <video
              autoPlay
              loop
              muted
              playsInline
              className={styles.workImage}
              src={image}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <Image
              src={image}
              alt={title}
              fill
              className={styles.workImage}
              sizes="(max-width: 768px) 100vw, 50vw"
              style={{ objectFit: "cover" }}
              unoptimized={image.endsWith('.gif')}
            />
          )}
          <div className={styles.workOverlay}>
            <svg className={styles.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="7" y1="17" x2="17" y2="7"></line>
              <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
          </div>
        </div>
        <div className={styles.workInfo}>
          <h3 className={styles.workTitle}>{title}</h3>
          <p className={styles.workCategory}>{category}</p>
        </div>
      </Link>
    </div>
  );
};

const Works = () => {
  // Sample works - in a real application, these would come from a CMS or API
  const works = [
    {
      id: 1,
      title: 'Add Metadata & Tags',
      link: 'features',
      isFeatureCard: true,
      isMetadataCard: true
    },
    {
      id: 2,
      image: '/images/landing/Prototype a swoosh sound.png',
      title: 'Visually search, tag, and version your SFX assets before you commit to final sound design',
      link: 'features',
      isFeatureCard: true
    },
    {
      id: 3,
      image: '/images/landing/Untitled design (5).png',
      title: 'Turn Ideas into Audio. Then Drop Them Into Your Build.',
      link: 'dashboard',
      isFeatureCard: true,
      hasButton: true
    }
  ];

  return (
    <section className={styles.works} id="works">
      <div className={styles.worksContainer}>
        <h2 className={styles.worksTitle}> The Unfair Advantage for Creators.</h2>

        {/* Removed: capability banner */}

        {/* Outer Overlap Wrapper start */}
        <div className={styles.outerOverlapWrapper}>
          <div className={styles.outerOverlapContent}>

            {/* Bento Grid Features Showcase */}
            <div className={styles.bentoGrid}>

              {/* Card 1: Profile (Left, Tall) */}
              <div className={`${styles.bentoCard} ${styles.cardProfile}`}>
                <Image
                  src="/landing/creative_producer_hyper_cinematic.png"
                  alt="Creative Professional"
                  fill
                  className={styles.profileImage}
                />
                <div className={styles.profileOverlay}>
                  <h3 className={styles.profileName}>Leo Hale</h3>
                  <p className={styles.profileRole}>Freelance Audio Director</p>
                  <div className={styles.experienceTags}>
                    <span className={styles.tag}>Sound Design</span>
                    <span className={styles.tag}>Mixing</span>
                    <span className={styles.tag}>AI Workflow</span>
                  </div>
                </div>
              </div>

              {/* Card 2: Testimonial (Center Top) */}
              <div className={`${styles.bentoCard} ${styles.cardTestimonial}`}>
                <p className={styles.quote}>
                  "Zenyai elevated our soundscape with a level of polish and creativity that exceeded every expectation. The process felt effortless."
                </p>
                <div className={styles.author}>
                  <span>Maya J.</span>
                  <span style={{ opacity: 0.5 }}>Film Student, UCLA</span>
                </div>
              </div>

              {/* Card 3: Tool Stack (Right, spans 2 on mobile but 4 here/middle) */}
              <div className={`${styles.bentoCard} ${styles.cardTools}`}>
                <div className={styles.toolsContainer}>
                  <div className={styles.centerOrb}></div>
                  {/* Creative Tool Icons */}
                  <div className={styles.toolIcon} style={{ top: '20%', left: '20%', transform: 'rotate(-10deg)' }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>
                  </div>
                  <div className={styles.toolIcon} style={{ top: '60%', left: '70%', transform: 'rotate(15deg)' }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                  </div>
                  <div className={styles.toolIcon} style={{ top: '30%', right: '20%', transform: 'rotate(5deg)' }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                  </div>
                  <div className={styles.toolIcon} style={{ bottom: '20%', left: '40%', transform: 'rotate(-5deg)' }}>
                    <span style={{ fontSize: '10px', fontWeight: 'bold', color: 'white' }}>AI</span>
                  </div>
                </div>
              </div>

              {/* Card 4: Stats (Center Bottom) */}
              {/* Card 4: Stats - Now just the film image */}
              <div className={`${styles.bentoCard} ${styles.cardStats}`}>
                <Image
                  src="/landing/film_director_hyper_cinematic.png?v=3"
                  alt="Film Director"
                  fill
                  className={styles.statsImage}
                />
              </div>

              {/* Card 5: CTA (Right Bottom) */}
              <div className={`${styles.bentoCard} ${styles.cardCta}`}>
                <div>
                  <h3 className={styles.workTitle} style={{ fontSize: '1.5rem', color: '#FFFFFF' }}>Stop Editing. Start Directing.</h3>
                  <p className={styles.workCategory} style={{ fontSize: '0.9rem' }}>Start your journey with Zenyai today.</p>
                </div>

                <Link href="/editor" className={`${styles.button} ${styles.primaryButton}`} style={{ width: '100%', marginTop: '1rem' }}>
                  Start Creating <span className={styles.arrow}>→</span>
                </Link>
              </div>

            </div>

            {/* Spacer to preserve original vertical spacing after removing workflow card */}
            <div className={styles.workflowSpacer} aria-hidden="true" />

            {/* Removed placeholder faded card */}

          </div>{/* outerOverlapContent */}
        </div>{/* outerOverlapWrapper */}

        {/** ScrollVelocity Section removed per request */}
        {/**
        <div className={styles.scrollVelocityContainer}>
          <ScrollVelocity
            texts={['SFX Generation', 'Music Creation', 'Voice Synthesis', 'Audio Search']} 
            velocity={50} 
            className="custom-scroll-text"
          />
        </div>
        */}

        {/* Description text - Now in the center above the button */}
        <div className={styles.centerDescriptionContainer}>
        </div>

        {/** Bottom CTA removed per request */}
        {/**
        <div className={styles.bottomButtonContainer}>
          <Link href="dashboard" className={`${styles.button} ${styles.primaryButton}`} style={{ fontWeight: 700, minWidth: '220px' }}>
            Start Generating Audio <span className={styles.arrow}>→</span>
          </Link>
        </div>
        */}
      </div>
    </section>
  );
};

export default Works; 